import { ReactElement } from "react";
import { StorefrontLayout } from "./StorefrontLayout";

export const StorefrontLayoutRoute = (): ReactElement => <StorefrontLayout />;
